<template>
	<p-card>
		<div class="tw-flex tw-justify-between tw-pb-4">
			<h4 class="font-weight-bold text-info">Seleccionar grados</h4>
			<div class="tw-flex tw-items-center tw-justify-center">
				<p class="text-primary tw-m-0 tw-mr-4">Agregar Grado</p>
				<v-btn
					class="custom-button custom-button-square"
					color="primary"
					@click="$refs.addDegreeDialog.show()"
				>
					<v-icon>add</v-icon>
				</v-btn>
			</div>
		</div>
		<div class="degree-table tw--mx-6">
			<div class="tw-flex degree-table-header">
				<div class="tw-w-9/12 tw-px-4 tw-py-2 text-primary tw-pl-20">
					Grados
				</div>
				<div
					class="tw-w-3/12 tw-px-4 tw-py-2 text-primary tw-text-center"
					style="border-left: 1px solid #e9e9e9;"
				>
					Puntos
				</div>
			</div>
			<div id="degree-table">
				<degree-table-row
					v-for="degree in degreeList"
					:key="degree.uuid"
					:degree="degree"
					:class="`degree-${degree.uuid}`"
					:checked="degree.selected"
					:is-pg-max="degreeIsPGmax(degree)"
					:is-pg-min="degreeIsPGmin(degree)"
					@onCheckedChange="onDegreeCheckChange"
					@onDeleteClick="onDeleteClicked"
					@onEditClick="onEditClick"
				/>
			</div>
			<p-confirm-dialog ref="confirmDialog" />
			<add-degree-dialog
				ref="addDegreeDialog"
				@degreeAdded="onDegreeAdded"
				@degreeUpdated="onDegreeUpdated"
			/>
		</div>
	</p-card>
</template>

<script>
import DegreeTableRow from '@/modules/job-evaluation/components/supplies/valuation-model/valuation-model/degrees/DegreeTableRow';
import Sortable from 'sortablejs';
import {
	head,
	prop,
	propEq,
	last,
	findIndex,
	move,
	assoc,
	update,
	reject,
	prepend,
} from 'ramda';
import PConfirmDialog from '@/modules/shared/components/ui/p-confirm-dialog';
import PCard from '@/modules/shared/components/ui/Card/p-card';
import AddDegreeDialog from '@/modules/job-evaluation/components/supplies/valuation-model/valuation-model/degrees/AddDegreeDialog';

export default {
	name: 'DegreeTable',
	components: { AddDegreeDialog, PCard, PConfirmDialog, DegreeTableRow },
	props: ['degreeList', 'selectedDegrees'],
	data() {
		return {
			$sortable: undefined,
		};
	},
	mounted() {
		this.initSortable();
	},
	methods: {
		initSortable() {
			const table = document.getElementById('degree-table');
			this.$sortable = new Sortable(table, {
				handle: '.drag-handler', // handle's class
				animation: 150,
				onEnd: (event) => {
					this.applyMovementInDegreeList(event, this.degreeList);
				},
			});
		},
		onDegreeCheckChange({ degree, checked }) {
			const indexFound = findIndex(
				propEq('uuid', degree.uuid),
				this.degreeList,
			);
			this.emitDegreesChange(
				update(indexFound, assoc('selected', checked, degree), this.degreeList),
			);
		},
		onEditClick(degree) {
			this.$refs.addDegreeDialog.edit(degree);
		},
		onDeleteClicked(degree) {
			this.$refs.confirmDialog.showConfirm({
				onOk: () => {
					this.emitDegreesChange(
						reject(propEq('uuid', degree.uuid), this.degreeList),
					);
				},
				title: '¿Seguro que desea eliminar el elemento de la lista?',
			});
		},
		onDegreeUpdated({ updatedDegree, oldDegree }) {
			const foundIndex = findIndex(
				propEq('uuid', oldDegree.uuid),
				this.degreeList,
			);
			this.emitDegreesChange(
				update(foundIndex, updatedDegree, this.degreeList),
			);
		},
		onDegreeAdded(degree) {
			this.emitDegreesChange(prepend(degree, this.degreeList));
		},
		degreeIsPGmax(degree) {
			return prop('uuid', degree) === prop('uuid', head(this.selectedDegrees));
		},
		degreeIsPGmin(degree) {
			return prop('uuid', degree) === prop('uuid', last(this.selectedDegrees));
		},
		applyMovementInDegreeList({ oldIndex, newIndex }, list) {
			this.emitDegreesChange(move(oldIndex, newIndex, list));
		},
		emitDegreesChange(newDegreeList) {
			this.$emit('degreeListChange', newDegreeList);
		},
	},
};
</script>

<style lang="scss" scoped>
.degree-table {
	.degree-table-header {
		background-color: #f5f5f5;
	}
}
</style>



// WEBPACK FOOTER //
// src/modules/job-evaluation/components/supplies/valuation-model/valuation-model/degrees/DegreeTable.vue